

import { useNavigate } from 'react-router-dom';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS, ERROR_MESSAGES, MARRIED_FAMILY_SITUATION_CODE } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { isPropositionInLock } from '../../utils/dataUtils';
import MgpFormSelect from '../../elements/MgpFormSelect/MgpFormSelect';
import { useFetchNomenclature } from '../../hooks/useFetchNomenclature';
import { useEffect } from 'react';
import { formatDateFR, getAllIndexByString } from '../../utils/utils';


type InfoPersoStep1FormData = {
  familySituationCode: string;
  birthPlace: string;
  birthName: string;
  firstName: string;
}



export default function InfoPersoStep1FormComponent() {

  const navigate = useNavigate();
  const familySituationNomenclature = useFetchNomenclature("familySituation");
 

  const {
    state: { proposition, updatedProposition },
    dispatch,
  } = useAppState();


  const validationSchema = Yup.object().shape({
    birthPlace: Yup.string()
      .required(ERROR_MESSAGES.requiredMsg)
      .min(3, ERROR_MESSAGES.invalidMsg)
      .max(30, ERROR_MESSAGES.invalidMsg),
    familySituationCode: Yup.string()
      .required(ERROR_MESSAGES.requiredMsg),
    birthName: Yup.string()
      .when('familySituationCode', {
        is: (value:string)=> value === MARRIED_FAMILY_SITUATION_CODE,
        then: (schema) => schema.required(ERROR_MESSAGES.requiredMsg) 
          .min(2, ERROR_MESSAGES.invalidMsg)
          .max(39, ERROR_MESSAGES.invalidMsg)
          .matches(/^[a-zA-Z '-]+$/i, ERROR_MESSAGES.invalidName)
          .test('invalidCombination', ERROR_MESSAGES.invalidMsg, (val)=> {
            let invalidCase = val?.includes('--') === true ;
            let isDashInTheMiddle;
            if(val){
              const indexList = getAllIndexByString(val, "-");
              isDashInTheMiddle = indexList.indexOf(0) !== -1 || indexList.indexOf(val.length-1) !== -1;
            }
            return !invalidCase && !isDashInTheMiddle;
          }),
        otherwise: (schema) => schema.notRequired()
    }),
    firstName: Yup.string()
      .required(ERROR_MESSAGES.requiredMsg)
      .min(2, ERROR_MESSAGES.invalidMsg)
      .max(50, ERROR_MESSAGES.invalidMsg)
      .matches(/^[a-zA-Z '-]+$/i, ERROR_MESSAGES.invalidName)
      .test('invalidCombination', ERROR_MESSAGES.invalidMsg, (val)=> {
        let invalidCase = val?.includes('--') === true ;
        let isDashInTheMiddle;
        if(val){
          const indexList = getAllIndexByString(val, "-");
          isDashInTheMiddle = indexList.indexOf(0) !== -1 || indexList.indexOf(val.length-1) !== -1;
        }
        return !invalidCase && !isDashInTheMiddle;
      }),
  });
    

  const {
    register,
    handleSubmit,
    setValue, watch,
    formState: { errors },
  } = useForm<InfoPersoStep1FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      familySituationCode: updatedProposition?.familySituationCode ? updatedProposition?.familySituationCode : '',
      birthPlace: updatedProposition?.birthPlace ? updatedProposition.birthPlace : "",
      birthName: updatedProposition?.birthName ?? "",
      firstName: updatedProposition?.firstName ? updatedProposition?.firstName : "",

    },
    resolver: yupResolver(validationSchema),
  });


  useEffect(() => {
      if(familySituationNomenclature && updatedProposition?.familySituationCode) {
        setValue("familySituationCode", updatedProposition?.familySituationCode);
      }
  }, [familySituationNomenclature]);

  const onNextAction = (data: InfoPersoStep1FormData) => {
    let tempUpdatedPropo = updatedProposition;
    if(tempUpdatedPropo) {
      tempUpdatedPropo.familySituationCode = data.familySituationCode;
      tempUpdatedPropo.birthPlace = data.birthPlace;
      tempUpdatedPropo.birthName = data.familySituationCode === MARRIED_FAMILY_SITUATION_CODE ? data.birthName.replaceAll("'", " ") : "";
      tempUpdatedPropo.firstName = data.firstName.replaceAll("'", " ");
    }

    dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoPersoStep2Page, updatedProposition: tempUpdatedPropo});
    navigate({
      pathname: APP_URLS.infoPersoStep2Page,
      search: `?id=${proposition!.propositionId}`,
    });
    
  }

  const onPreviousAction = () => {
    if(proposition!.configuration.hasShowPriceAmount) {
      dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoPersoStep0Page});
      navigate({
        pathname: APP_URLS.infoPersoStep0Page,
        search: `?id=${proposition!.propositionId}`,
      });
    } else {
      dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.bienvenuePage});
      navigate({
        pathname: APP_URLS.bienvenuePage,
        search: `?id=${proposition!.propositionId}`,
      });
    }
  }

    return (             
      <form style={{width: '100%'}}>
        <div className='form-row page-content'>
          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
              <h2 className='card-title bleu'>Mon identité : </h2>
              <div className='form-row'>
                <div className="form-group mw-100">
                  <MgpFormInput
                      label="Civilité"
                      id="civility"
                      labelFontWeight='regular'
                      disabled={true}
                      value={proposition?.contact.civilityLabel?.toUpperCase()}
                  />
                </div>
              </div>

              <div className='form-row'>
                <div className="form-group mw-100">
                  <MgpFormInput
                      label="Prénom"
                      id="firstName"
                      labelFontWeight='regular'
                      errors={errors}
                      register={register}
                      required
                      autoCapitalize="characters"
                  />
                </div>
              </div>

              <div className='form-row'>
                <div className="form-group mw-100">
                  <MgpFormInput
                      label="Nom"
                      id="lastName"
                      labelFontWeight='regular'
                      disabled={true}
                      value={proposition?.contact.lastName?.toUpperCase()}
                  />
                </div>
              </div>

              {watch('familySituationCode') === MARRIED_FAMILY_SITUATION_CODE &&
                <div className='form-row'>
                  <div className="form-group mw-100">
                    <MgpFormInput
                      label="Nom de naissance"
                      id="birthName"
                      labelFontWeight='regular'
                      register={register} 
                      errors={errors}
                      required={true}
                      autoCapitalize='characters'
                      maxLength={39}
                    />
                  </div>
                </div>
              }
            
          </div>
          
          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
            <div className='pb-md mt-lg'>
              <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput
                        label="Date de naissance"
                        id="birthDate"
                        labelFontWeight='regular'
                        disabled={true}
                        value={proposition?.contact.birthDate
                          ? formatDateFR(proposition?.contact.birthDate)
                          : ""}
                    />
                </div>
              </div>  

              <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput
                        label="Lieu de naissance"
                        id="birthPlace"
                        labelFontWeight='regular'
                        register={register} 
                        errors={errors}
                        required={true}
                        placeholder='Ex: Paris'
                        maxLength={30}
                    />
                </div>
              </div>  
              
              <div className='form-row'>
                <div className="form-group mw-100">
                  <MgpFormSelect id="familySituationCode" labelFontWeight='regular' data={familySituationNomenclature.options} label="Situation familiale" register={register} errors={errors} required={true}/>
                </div>
              </div>                
            </div>
             
            <div className="mt-xl">
              <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
            </div>
          </div>
        </div>
          
        {proposition && isPropositionInLock(proposition) ? (<StickButtonsBloc disabledPreviousButton={true} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>) : (<StickButtonsBloc showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>)}
        
      </form>
  )
}
